module.exports = __webpack_public_path__ + "img/logo1 (13).b7c7c465.jpg";